export interface Origin {
  id: string;
  key: string;
  description: string;
}
